// FIXME: Use this component instead of the other custom ones MAGGIE-3441.
import { AvatarProps } from '@mui/material/Avatar/Avatar';
import { Avatar, useTheme } from '@mui/material';
import { css } from '@emotion/react';
import { CSSProperties, ReactNode } from 'react';
import { getInitials } from '../../util/stringUtils';

const imgStyle = css`
  .MuiAvatar-img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export type AvatarSize = 'gridCell' | 'small' | 'medium' | 'large' | 'mediumLarge' | 'xlarge';

export type MUIAvatarSettings = Pick<
  AvatarProps<React.ElementType, unknown>,
  'fontSize' | 'height' | 'width'
>;

export interface IMUIAvatarProps {
  nameParts: string[];
  src: string | null;
  size?: AvatarSize;
  style?: CSSProperties | undefined;
  title?: string;
  /** Shown in place of the initials; `title` (else the name) then becomes the avatar's accessible name. */
  icon?: ReactNode;
}

export const avatarSizeMapping: Record<AvatarSize, MUIAvatarSettings> = {
  gridCell: {
    fontSize: 14,
    height: 24,
    width: 24,
  },
  small: {
    fontSize: 10,
    height: 24,
    width: 24,
  },
  medium: {
    fontSize: 14,
    height: 30,
    width: 30,
  },
  large: {
    fontSize: 20,
    height: 56,
    width: 56,
  },
  mediumLarge: {
    fontSize: 24,
    height: 48,
    width: 48,
  },
  /** The V2 Leadership avatar: 80px with 24px initials, per design. */
  xlarge: {
    fontSize: 24,
    height: 80,
    width: 80,
  },
};

export function MUIAvatar({ nameParts, src, style, size = 'small', title, icon }: IMUIAvatarProps) {
  const theme = useTheme();
  const [namePart1, namePart2] = nameParts;
  const fullName = `${namePart1 ?? ''} ${namePart2 ?? ''}`;
  const initials = getInitials(nameParts);
  const sizeDetails = avatarSizeMapping[size];

  return (
    <Avatar
      alt={fullName}
      src={src ?? ''}
      css={imgStyle}
      style={style}
      sx={{
        bgcolor: src ? undefined : theme.colors.primary[10],
        color: 'inherit',
        ...sizeDetails,
      }}
      {...(icon ? { role: 'img', 'aria-label': title ?? fullName } : { title: title ?? fullName })}
    >
      {icon ?? initials}
    </Avatar>
  );
}
